module.exports = __webpack_public_path__ + "media/site_templates/www.hirecarpenters.com.au/images/our_services_3-853d7106d858c3e20f9108fc9f6582c4.jpg";